import * as React from 'react'
import { MenuItem, Menu, List, ListItem, ListItemText, Collapse } from '@material-ui/core'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

export default function CalificacionesCondicion ({ calificaciones, condicionInicial, onSelectCondicionIngreso, changeForm }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [selectedCalificacion, setSelectedCalificacion] = React.useState(condicionInicial)
  const open = Boolean(anchorEl)
  const [textMenu, setTextMenu] = React.useState('Seleccione una condicion')

  const handleClickListItem = (e) => {
    setAnchorEl(e.currentTarget)
  }

  if (!selectedCalificacion && condicionInicial) {
    setSelectedCalificacion(condicionInicial)
  }

  const [openAmpliado, setOpenAmpliado] = React.useState(false)

  const handleClick = () => {
    setOpenAmpliado(!openAmpliado)
  }

  const handleMenuItemClick = (e, calificacion, i) => {
    changeForm(i)
    setSelectedCalificacion(calificacion)
    setAnchorEl(null)
    setOpenAmpliado(false)
    setTextMenu('')
    onSelectCondicionIngreso(i)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setOpenAmpliado(false)
  }

  if (!(calificaciones instanceof Array) || (calificaciones && (calificaciones.length < 1))) { return null }

  const calificacionesFrecuentes = calificaciones.filter(calificacion => calificacion.indice > 0)
  const calificacionesNoFrecuentes = calificaciones.filter(calificacion => calificacion.indice === 0)

  return (
    <div>
      {calificaciones && <>
        <div style={{ backgroundColor: 'rgb(228 228 228)' }} className={'paper-calificaciones'} >
          <List
            style={{ margin: '0', padding: '0' }}
            component='nav'
            aria-label='Device settings'
          >
            <ListItem
              style={{ padding: '0', width: '100%' }}
              button
              aria-label='condicion seleccionada'
              onClick={handleClickListItem}
            >
              <ListItemText
                style={{ margin: '5px 15px' }}
                secondary={textMenu}
                primary={[selectedCalificacion]}
              />
            </ListItem>

            <Menu
              id='lock-menu'
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left'
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
            >
              {calificacionesFrecuentes.map((calificacion) => (
                <MenuItem
                  key={calificacion.calificacionCereal}
                  selected={calificacion.nombre === selectedCalificacion}
                  onClick={(e) => handleMenuItemClick(e, calificacion.nombre, calificacion.calificacionCereal)}
                >
                  {calificacion.nombre}
                </MenuItem>
              ))
              }
              <ListItem button onClick={handleClick}>
                <ListItemText primary='' />
                {openAmpliado ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </ListItem>
              <Collapse in={openAmpliado} timeout='auto' unmountOnExit>
                {calificacionesNoFrecuentes.map((calificacion) => (
                  <MenuItem
                    key={calificacion.calificacionCereal}
                    selected={calificacion.nombre === selectedCalificacion}
                    onClick={(e) => handleMenuItemClick(e, calificacion.nombre, calificacion.calificacionCereal)}
                  >
                    {calificacion.nombre}
                  </MenuItem>
                ))
                }
                <ListItem button onClick={handleClick}>
                  <ListItemText primary='' />
                  {openAmpliado ? <ExpandLessIcon style={{ outline: 'none' }} /> : <ExpandMoreIcon style={{ outline: 'none' }} />}
                </ListItem>
              </Collapse>
            </Menu>
          </List>
        </div>
      </>}
    </div>
  )
}
